var burger = [
    {
        "id": "25",
        "name": "Bob's Burger Barn",
        "category": "burger",
        "img": "https://i.imgur.com/WrJzPxP.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 4.99
    },
    {
        "id": "26",
        "name": "Burger Bros Ahoy",
        "category": "burger",
        "img": "https://i.imgur.com/x7ydJJh.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 5.99
    },
    {
        "id": "27",
        "name": "Bigger Better Burger Joint",
        "category": "burger",
        "img": "https://i.imgur.com/MGzTqhg.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 4.59
    },
    {
        "id": "28",
        "name": "The Burger King",
        "category": "burger",
        "img": "https://i.imgur.com/A3SFVZB.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price":5.99
    },
    {
        "id": "29",
        "name": "Buzz Burgers Chicken",
        "category": "burger",
        "img": "https://i.imgur.com/wJBDIXL.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 4.99
    },
    {
        "id": "30",
        "name": "Patty Buns Burgers",
        "category": "burger",
        "img": "https://i.imgur.com/FTbZrCC.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 5.99
    },


]
export default burger;